<div
    class="flex w-full flex-auto flex-col items-center justify-center gap-6 px-6 py-16 text-center"
>
    <div
        class="flex h-16 w-16 items-center justify-center rounded-full bg-warn/10 text-warn"
    >
        <mat-icon class="icon-size-10" [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
    </div>

    <div class="flex max-w-lg flex-col gap-2">
        <h1 class="text-2xl font-semibold tracking-tight text-default">
            {{ 'ACCESS_DENIED.TITLE' | transloco }}
        </h1>
        <p class="text-secondary">
            {{ 'ACCESS_DENIED.MESSAGE' | transloco }}
        </p>
        @if (attemptedUrl) {
            <p class="mt-2 break-all text-sm text-hint">
                <span class="font-medium">{{ 'ACCESS_DENIED.ATTEMPTED' | transloco }}:</span>
                {{ attemptedUrl }}
            </p>
        }
    </div>

    <div class="flex flex-wrap items-center justify-center gap-3">
        <button mat-flat-button color="primary" type="button" (click)="goToStart()">
            {{ 'ACCESS_DENIED.GO_HOME' | transloco }}
        </button>
    </div>
</div>
